import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RoutesPath } from "../constants";

const AuthenticatedRoutes = () => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");

  if (isAuthenticated === null) {
    return <div>Loading secure content...</div>;
  }

  return isAuthenticated === "true" ? (
    <Outlet />
  ) : (
    <Navigate to={RoutesPath.LOGIN} replace />
  );
};

export default AuthenticatedRoutes;